import React, { createContext, useReducer } from "react";
import * as actionTypes from "./actions/actionTypes";

export const StoreContext = createContext();
const initialState = {
    locale: "en-us",
    email: "",
    loading: {
        isLoading: false,
        eventName: "",
    },
    isLoadingGlobal: false,
    sessionId: "",
    sessionExpiration: null,
    profile: {
        preferredLanguage: "",
        firstName: "",
        lastName: "",
        industry: "",
        jobRole: "",
        jobTitle: "",
        organization: "",
        location: "",
        gpcOverride: false,
        emailables: {
            developer: {
                subscribed: null,
            },
            enterprise: {
                subscribed: null,
            },
            gaming: {
                subscribed: null,
            },
            startups: {
                subscribed: null,
            },
        },
        dataSharing: {
            interestBasedAds: {
                subscribed: null,
            },
            targetedAdsOptIn: {
                subscribed: null,
                segment: "gaming",
                version: TARGETED_ADS_CONSENT_VERSION,
            },
        },
        meta: {},
    },
    segments: [],
    idToken: "",
    accessToken: "",
    message: "",
    industries: [],
    jobRoles: [],
    jobTitles: [],
    countries: [],
    languages: [],
    geoInfo: {},
    topics: {
        segments: [],
        emailables: [],
        dataSharing: [],
    },
    target: "/preferences/start/",
};

const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.GET_USER_GEO_INFO_REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_USER_GEO_INFO_SUCCESS:
            return {
                ...state,
                geoInfo: action.payload.geoInfo,
            };
        case actionTypes.SET_REDIRECT_TARGET:
            return {
                ...state,
                target: action.payload.target,
            };
        case actionTypes.AUTH_LOGOUT:
            return {
                ...state,
                accessToken: "",
                email: "",
                sessionId: "",
                idToken: "",
            };
        case actionTypes.GET_PROFILE_REQUEST:
            return {
                ...state,
                accessToken: action.payload.accessToken,
                idToken: action.payload.idToken,
            };
        case actionTypes.GET_PROFILE_SUCCESS:
            return {
                ...state,
                email: action.payload.email,
                matchVersion: action.payload.matchVersion,
            };
        case actionTypes.GET_PROFILE_FAILURE:
            return {
                ...state,
            };
        case actionTypes.GET_EXTENDED_USER_PROFILE_REQUEST:
            return {
                ...state,
                idToken: action.payload.idToken,
            };
        case actionTypes.GET_EXTENDED_USER_PROFILE_SUCCESS:
            return {
                ...state,
            };
        case actionTypes.GET_EXTENDED_USER_PROFILE_FAILURE:
            return {
                ...state,
            };
        case actionTypes.UPDATE_EXTENDED_USER_PROFILE_REQUEST:
            return {
                ...state,
            };
        case actionTypes.UPDATE_EXTENDED_USER_PROFILE_SUCCESS:
            return {
                ...state,
                profile: action.payload.profile,
            };
        case actionTypes.UPDATE_EXTENDED_USER_PROFILE_FAILURE:
            return {
                ...state,
            };
        case actionTypes.EMAIL_SIGNUP_REQUEST:
            return {
                ...state,
                email: action.payload.email,
            };
        case actionTypes.EMAIL_SIGNUP_SUCCESS:
            return {
                ...state,
                segments: action.payload.segments,
                profile: {
                    ...state.profile,
                    emailables: {
                        ...state.profile.emailables,
                        ...action.payload.emailables,
                    },
                },
            };
        case actionTypes.EMAIL_SIGNUP_FAILURE:
            return {
                ...state,
            };
        case actionTypes.GET_ALL_INDUSTRIES_REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_ALL_INDUSTRIES_SUCCESS:
            return {
                ...state,
                industries: action.payload.response,
            };
        case actionTypes.GET_ALL_INDUSTRIES_FAILURE:
            return {
                ...state,
            };
        case actionTypes.GET_ALL_COUNTRIES_REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_ALL_COUNTRIES_SUCCESS:
            return {
                ...state,
                countries: action.payload.response,
            };
        case actionTypes.GET_ALL_COUNTRIES_FAILURE:
            return {
                ...state,
            };
        case actionTypes.GET_ALL_LANGUAGES_REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_ALL_LANGUAGES_SUCCESS:
            return {
                ...state,
                languages: action.payload.response,
            };
        case actionTypes.GET_ALL_LANGUAGES_FAILURE:
            return {
                ...state,
            };
        case actionTypes.GET_ALL_JOB_ROLES_REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_ALL_JOB_ROLES_SUCCESS:
            return {
                ...state,
                jobRoles: action.payload.response,
            };
        case actionTypes.GET_ALL_JOB_ROLES_FAILURE:
            return {
                ...state,
            };
        case actionTypes.GET_ALL_JOB_TITLES_REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_ALL_JOB_TITLES_SUCCESS:
            return {
                ...state,
                jobTitles: action.payload.response,
            };
        case actionTypes.GET_ALL_JOB_TITLES_FAILURE:
            return {
                ...state,
            };
        case actionTypes.GET_TOPICS_REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_TOPICS_SUCCESS:
            return {
                ...state,
                topics: action.payload.response,
            };
        case actionTypes.GET_TOPICS_FAILURE:
            return {
                ...state,
            };
        case actionTypes.SET_LOCALE_SUCCESS:
            return {
                ...state,
                locale: action.payload,
            };
        case actionTypes.SET_BAR_MESSAGE:
            return {
                ...state,
                message: action.payload.message,
            };
        case actionTypes.SET_LOADING:
            return {
                ...state,
                loading: {
                    isLoading: action.payload.isLoading,
                    eventName: action.payload.eventName,
                },
            };
        case actionTypes.SET_LOADING_GLOBAL:
            return {
                ...state,
                isLoadingGlobal: action.payload.isLoading,
            };
        case actionTypes.REMOVE_BAR_MESSAGE:
            return {
                ...state,
                message: "",
            };
        case actionTypes.UNSUBSCRIBE_REQUEST:
            return {
                ...state,
                email: action.payload.email,
            };
        case actionTypes.UNSUBSCRIBE_SUCCESS:
            return {
                ...state,
            };
        case actionTypes.UNSUBSCRIBE_FAILURE:
        case actionTypes.SHARE_FEEDBACK_FAILURE:
        case actionTypes.GET_PIN_FAILURE:
        case actionTypes.GET_USER_GEO_INFO_FAILURE:
        case actionTypes.VERIFY_PIN_FAILURE:
        case actionTypes.GET_PREFERENCES_FAILURE:
        case actionTypes.SET_PREFERENCES_FAILURE:
            return {
                ...state,
            };
        case actionTypes.SHARE_FEEDBACK_REQUEST:
            return {
                ...state,
            };
        case actionTypes.SHARE_FEEDBACK_SUCCESS:
            return {
                ...state,
            };
        case actionTypes.GET_PIN_REQUEST:
            return {
                ...state,
                email: action.payload.email,
            };
        case actionTypes.GET_PIN_SUCCESS:
            return {
                ...state,
                sessionExpiration: action.payload.sessionExpiration,
                sessionId: action.payload.response.sessionId,
            };
        case actionTypes.VERIFY_PIN_REQUEST:
            return {
                ...state,
            };
        case actionTypes.VERIFY_PIN_SUCCESS:
            return {
                ...state,
                sessionExpiration: action.payload.sessionExpiration,
            };
        case actionTypes.GET_PREFERENCES_REQUEST:
            return {
                ...state,
                email: action.payload.email,
                sessionId: action.payload.sessionId,
                token: action.payload.token,
            };
        case actionTypes.GET_PREFERENCES_SUCCESS:
            let newSegments = [];
            newSegments = action.payload.response.areasOfInterest
                ?.map((item) => item.machineName)
                .filter((item) => {
                    return item !== "dev_ent_opt_in" && item !== "gaming_entertainment";
                });
            return {
                ...state,
                profile: {
                    ...state.profile,
                    preferredLanguage: action.payload.response.location?.preferredLanguage || "",
                    firstName: action.payload.response.firstName || "",
                    lastName: action.payload.response.lastName || "",
                    location: action.payload.response.location?.country || "",
                    industry: action.payload.response.userOrg?.industry || "",
                    jobRole: action.payload.response.userOrg?.jobRole || "",
                    jobTitle: action.payload.response.userOrg?.jobTitle || "",
                    organization: action.payload.response.userOrg?.organization || "",
                    gpcOverride: action.payload.response.gpcOverride || false,
                    emailables: {
                        developer: {
                            ...state.profile.emailables.developer,
                            subscribed: action.payload.response.developer
                                ? action.payload.response.developer.subscribed
                                : null,
                        },
                        enterprise: {
                            ...state.profile.emailables.enterprise,
                            subscribed: action.payload.response.enterprise
                                ? action.payload.response.enterprise.subscribed
                                : null,
                        },
                        gaming: {
                            ...state.profile.emailables.enterprise,
                            subscribed: action.payload.response.gaming
                                ? action.payload.response.gaming.subscribed
                                : null,
                        },
                        startups: {
                            ...state.profile.emailables.startups,
                            subscribed: action.payload.response.startups
                                ? action.payload.response.startups.subscribed
                                : null,
                        },
                    },
                    dataSharing: {
                        interestBasedAds: {
                            ...state.profile.dataSharing.interestBasedAds,
                            subscribed: action.payload.response.interestBasedAds
                                ? action.payload.response.interestBasedAds.subscribed
                                : null,
                        },
                        targetedAdsOptIn: {
                            ...state.profile.dataSharing.targetedAdsOptIn,
                            subscribed: action.payload.response.targetedAdsOptIn
                                ? action.payload.response.targetedAdsOptIn.subscribed
                                : null,
                        },
                    },
                    meta: {
                        ...action.payload.response.meta,
                    },
                },
                segments: newSegments || [],
            };
        case actionTypes.SET_PREFERENCES_REQUEST:
            return {
                ...state,
            };
        case actionTypes.SET_PREFERENCES_SUCCESS:
            return {
                ...state,
                segments: action.payload.segments,
                profile: {
                    ...state.profile,
                    meta: {
                        ...action.payload.response.meta,
                    },
                },
            };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};

export const StoreProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return <StoreContext.Provider value={{ state, dispatch }}>{children}</StoreContext.Provider>;
};
